<template>
  <div style="border: 1px solid #ccc; z-index: 999">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :default-config="toolbarConfig"
      :mode="mode"
    />
    <Editor
      v-model="html"
      style="height: 300px; overflow-y: hidden"
      :default-config="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
      @onChange="onChange"
    />
  </div>
</template>
<script>
import "@wangeditor/editor/dist/css/style.css";
import Vue from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { getToken } from "@/utils/auth";
import { getLocale } from "@/utils/locale";

export default Vue.extend({
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editor: null,
      html: this.value,
      toolbarConfig: {},
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          uploadImage: {
            server: process.env.VUE_APP_BASE_API + "/api/upload/wang_editor",
            fieldName: "file",
            withCredentials: true,
            allowedFileTypes: ["image/*"],
            headers: {
              "X-User-Token": getToken(),
              "X-User-Locale": getLocale(),
            },
          },
        },
      },
      mode: "default", // or 'simple'
    };
  },
  mounted() {},
  beforeDestroy() {
    const editor = this.editor;
    if (editor != null) {
      editor.destroy(); // 组件销毁时，及时销毁编辑器
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    onChange(editor) {
      const value = editor.getHtml();
      this.$emit("input", value);
      this.$forceUpdate();
    },
  },
});
</script>
<style lang="scss" scoped></style>
